<ng-container *ngIf="viewObject$ | async as viewObject">
	<header class="page-header">
		<ul class="breadcrumb">
			<li>
				<a
					class="back"
					[routerLink]="TranslateComponent.getCloseLink(viewObject.translateParams.translation, viewObject.dependent)"
				>
					<i class="ico ico-arrow-back"></i><span class="label" translate="back"></span>
				</a>
			</li>
		</ul>
		<h1 *ngIf="!viewObject.dependent" translate="process.element.translate.title"></h1>
		<h1
			*ngIf="viewObject.dependent"
			translate="process.element.translate.type.title"
			[translateParams]="{ type: dependentElement!.type.name }"
		></h1>
	</header>
	<article class="translate-element">
		<stages-edit-translations
			[translateParams]="viewObject.translateParams"
			(cancelled)="cancel($event, viewObject.dependent)"
			(submitted)="save($event, viewObject.dependent)"
		/>
	</article>
</ng-container>
